import React from 'react'
import TeamItem from './TeamItem'

const Team = () => {
  return (
    <div className='flex flex-col flex-wrap relative w-full h-auto    mt-40 justify-center items-center'>
      <div className='container mx-auto flex flex-col flex-wrap justify-center items-center text-white'>
        <div className=' flex flex-wrap flex-col w-full h-auto font-medium justify-center items-center text-5xl'>
          Team

        </div>
        <div className=' w-full h-auto flex flex-row  mt-20  place-items-center'>
          <TeamItem />
          <TeamItem />
          <TeamItem />
          <TeamItem />
          <TeamItem />
        </div>
      </div>
    </div>
  )
}

export default Team